import { getPointMachineSwitchesAtLocations, getPointMachineSwitchesForBaneDataIds } from 'src/Providers/PointMachineSwitches'
import { getDateRange } from 'src/Features/SelectedDatePeriod/predefinedDatePeriods'
import { useAppStateStore } from 'src/Store/appState'
import { useQueryWithErrorHandling } from './useQueryWithErrorHandling'
import type { AggregatedAssetParams } from 'src/Hooks/NetworkData/useAggregatedAssets'

export const usePointMachineSwitchesWithAlarms = ({
  datePeriod,
  idType,
  ids,
  onlyWithAlarms = false,
  enableAllAlarmTypes = false,
  enabled = true,
}: AggregatedAssetParams) => {
  const lastUpdated = useAppStateStore(state => state.selectedDatePeriod.lastUpdated)

  const query = useQueryWithErrorHandling(
    ['pointMachineSwitchesWithAlarms', { idType, ids, datePeriod, onlyWithAlarms, enableAllAlarmTypes, lastUpdated, enabled }],
    () => {
      if (!datePeriod || !enabled) {
        return []
      }
      const dateRange = getDateRange(datePeriod)
      if (idType === 'baneDataLocationIds') {
        return getPointMachineSwitchesAtLocations(dateRange, ids, onlyWithAlarms, enableAllAlarmTypes)
      }

      return getPointMachineSwitchesForBaneDataIds(dateRange, ids, onlyWithAlarms, enableAllAlarmTypes)
    },
    {
      enabled: ids.length > 0,
    },
    'switches.fetchError'
  )

  return {
    ...query,
    pointMachineSwitchesWithAlarms: query.data,
  }
}
